const Winners = () => (
  <div className="mt-20 w-3/4 min-w-[320px] mb-20 mx-auto">
    <span className="section-title" id="winners">
      Winners
    </span>

    <span className="section-subtitle" id="winners">
      Poster Design
    </span>
    <div className="flex flex-wrap justify-evenly gap-5 gap-x-10">
      <div
        className="contact  flex justify-center items-center py-100 flex-col"
      >
        Gaviru Fernando
        <p className="text-[20px]">GRADE 11 | 1ST</p>
      </div>
      <div
        className="contact flex justify-center items-center py-100 flex-col"
      >
        Sahiru Dineepa
        <p className="text-[20px]">GRADE 11 | 2ND</p>
      </div>
      <div
        className="contact flex justify-center items-center py-100 flex-col"
      >
        Senura Perera
        <p className="text-[20px]">GRADE 11 | 3RD</p>
      </div>
    </div>

    <span className="section-subtitle mt-20" id="winners">
    Mockup Design
    </span>
    <div className="flex flex-wrap justify-evenly gap-5 gap-x-10">
      <div
        className="contact  flex justify-center items-center py-100 flex-col"
      >
        Sachintha Prabhashwara
        <p className="text-[20px]">GRADE 9 | 1ST</p>
      </div>
      <div
        className="contact flex justify-center items-center py-100 flex-col"
      >
        Sinura Nanayakkara
        <p className="text-[20px]">GRADE 11 | 2ND</p>
      </div>
      <div
        className="contact flex justify-center items-center py-100 flex-col"
      >
        Amiru Wijayasiriwardhane
        <p className="text-[20px]">GRADE 9 | 3RD</p>
      </div>
    </div>

    <span className="section-subtitle mt-20" id="winners">
    Photo Manipulation
    </span>
    <div className="flex flex-wrap justify-evenly gap-5 gap-x-10">
      <div
        className="contact  flex justify-center items-center py-100 flex-col"
      >
        Bihandu Fonseka
        <p className="text-[20px]">GRADE 11 | 1ST</p>
      </div>
      <div
        className="contact flex justify-center items-center py-100 flex-col"
      >
        Saviru Suraweera
        <p className="text-[20px]">GRADE 10 | 2ND</p>
      </div>
      <div
        className="contact flex justify-center items-center py-100 flex-col"
      >
        Sathira Kumarajith
        <p className="text-[20px]">GRADE 10 | 3RD</p>
      </div>
    </div>

    <span className="section-subtitle mt-20" id="winners">
      Video Editing
    </span>
    <div className="flex flex-wrap justify-evenly gap-5 gap-x-10">
      <div
        className="contact  flex justify-center items-center py-100 flex-col"
      >
        Amiru Wijayasiriwardhane
        <p className="text-[20px]">GRADE 10 | 1ST</p>
      </div>
      <div
        className="contact flex justify-center items-center py-100 flex-col"
      >
        Senitha Ranvidu
        <p className="text-[20px]">GRADE 12 | 2ND</p>
      </div>
    </div>
  </div>
);

export default Winners;
